<section class="main-section">
  <header class="d-flex justify-content-between align-items-center main-heading">
    <div class="d-flex align-items-center">
      <a class="btn btn-link me-3 p-0 d-block d-xl-none" data-bs-toggle="offcanvas" href="#offcanvasExample"
        role="button" aria-controls="offcanvasExample">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 7H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
          <path d="M3 12H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
          <path d="M3 17H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
        </svg></a>
      <h3 class="heading-span" *ngIf="currentStep == 0">
        <span>Individual School</span>
      </h3>
      <h3 class="heading-span" *ngIf="currentStep != 0">
        <span  class="underline" (click)="getIndependentSchools(pagination)">Individual School</span> / Create Individual School
      </h3>
    </div>
    <div class="d-flex">
      <div *ngIf="!createIndividualSchoolForm && currentStep == 0" class="d-flex">
      <div class="input-group user-center-search me-0">
        <span
          class="input-group-text bg-transparent"
          id="basic-addon1"
          (click)="getIndependentSchools(pagination)"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.7138 6.8382C18.1647 9.28913 18.1647 13.2629 15.7138 15.7138C13.2629 18.1647 9.28913 18.1647 6.8382 15.7138C4.38727 13.2629 4.38727 9.28913 6.8382 6.8382C9.28913 4.38727 13.2629 4.38727 15.7138 6.8382"
              stroke="#999999"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M19 19L15.71 15.71"
              stroke="#999999"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
        <input
          type="text"
          class="form-control usercenter-searchcontrol bg-white ps-0"
          placeholder="Search"
          aria-label="Username"
          [(ngModel)]="searchTerm"
          aria-describedby="basic-addon1"
          (keyup.enter)="getIndependentSchools(pagination)"
        />
      </div>
      <mat-icon matTooltip="Search by School Name / Address / Location / School Type / Curriculum / Local Authority / Assign Account Admin" class="fs-22 m-2">info</mat-icon>
    </div>
    <button type="button" *ngIf="!createIndividualSchoolForm && currentStep == 0" class="btn theme-btn px-2 ms-3 border-sm-0" (click)="sendBulkEmail()">
      <span class="d-block d-sm-none">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFF">
          <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z"/>
        </svg>
      </span>
      <span class="d-none d-sm-block">Send Bulk Email</span>
    </button>
      <div class="d-flex" *ngIf="!createIndividualSchoolForm && currentStep == 0">
   
        <button type="button" class="btn theme-btn px-2 ms-3 border-sm-0" (click)="onCreateIndependentSchool()">
          <span class="d-block d-sm-none"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M12 5V19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg></span>
          <span class="d-none d-sm-block">Create Individual School</span>
        </button>
      </div>
      <div class="d-flex" *ngIf="
          currentStep == steps.AssignPackage && userRole?.includes(role.SuperAdmin)
        ">
        <button type="button" class="btn theme-btn-outline px-sm-4 px-2 border-sm-0" (click)="
            currentStep = steps.CreatePackage;
            maxStep = currentStep > maxStep ? currentStep : maxStep;
            showForm = true;
            createIndividualSchoolForm = false;
            openedPackage = true;
          ">
          <span class="d-block d-sm-none"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M12 5V19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg></span>
          <span class="d-none d-sm-block">Create {{ activeTab }}</span>
        </button>
      </div>
    </div>
  </header>

  <div *ngIf="!createIndividualSchoolForm && currentStep == 0">
    <app-independent-entity (refreshData)="getIndependentSchools($event)" [schoolData]="schoolList"
      (actionTriggered)="actionTriggered($event)">
    </app-independent-entity>
  </div>
  
  
  <div class="create-block mw-100" *ngIf="
    !createIndividualSchoolForm &&
    !schoolList.length &&
    currentStep == 0
  ">
  <img alt="" class="" src="../assets/images/create-mat.svg" />
  <h3 class="my-4 pt-2 content-center">
    Create Individual Schools
  </h3>

  <div class="d-flex flex-wrap justify-content-center">
    <button type="button" class="btn theme-btn px-4 me-0 me-sm-3 mb-4" (click)="
        createIndividualSchoolForm = true;
        currentStep = steps.AssignPackage;
        maxStep = currentStep > maxStep ? currentStep : maxStep;">
        Create Individual School
    </button>
    
  </div>
  </div>
  <ul class="timeline-horizontal independentschool-timeline d-flex" *ngIf="createIndividualSchoolForm">
    <li
      [ngClass]="{'active': (currentStep == steps.AssignPackage || currentStep == steps.CreatePackage || currentStep == steps.EditPackage) , 'completed': (currentStep == steps.AddSchool || currentStep == steps.CreateRole || currentStep == steps.CreateUser) }"
      (click)="goToSelectedStep(steps.AssignPackage)">
      <div class="step"><span class="step-timeline">STEP 1</span></div>
      <div class="heading"><span class="step-timeline"></span>Select Package</div>
    </li>
    <li 
      [ngClass]="{'active': currentStep == steps.AddSchool , 'completed': currentStep == steps.CreateRole || currentStep == steps.CreateUser}"
      (click)="goToSelectedStep(steps.AddSchool)">
      <div class="step">STEP 2</div>
      <div class="heading">Add School</div>
    </li>
    <li 
      [ngClass]="{'active': currentStep == steps.CreateRole, 'completed': currentStep == steps.CreateUser}"
      (click)="goToSelectedStep(steps.CreateRole)">
      <div class="step">STEP 3</div>
      <div class="heading">Create Audience</div>
    </li>
    <li 
      [ngClass]="{'active': currentStep == steps.CreateUser, 'completed': completedProcess}"
      (click)="goToSelectedStep(steps.CreateUser)">
      <div class="step">STEP 4</div>
      <div class="heading">Create Member / User</div>
    </li>
  </ul>
  <div class="table-responsive" *ngIf="
      currentStep == steps.AssignPackage ||
      currentStep == steps.CreatePackage ||
      currentStep == steps.EditPackage">
    <app-package [openedFrom]="2" [showForm]="showForm"
      [selectedPackage]="packageToAssign" [isCurrentTab]="activeTab"
      (packageActionTriggered)="hideNavigationButtons($event)"
      (packageAssigned)="receivedPackage($event)">
    </app-package>
  </div>

  <div class="mat-account-wrapper">
    <div *ngIf="createIndividualSchoolForm && currentStep == steps.AddSchool">
      <app-add-school [isEdit] = "isEdit" [schoolData]="createdSchoolDetails" [isIndividualEntity] = true [accountAdminList]="accountAdminList"></app-add-school>
    </div>
    <div *ngIf="createIndividualSchoolForm && currentStep == steps.CreateRole">
      <app-create-role [openedFromIndividualSchool]="createIndividualSchoolForm" [roleData]="roles" [isEdit] = "isEdit" [assignedPackageId]="packageToAssign"></app-create-role>
    </div>
    <div *ngIf="createIndividualSchoolForm && currentStep == steps.CreateUser">
      <app-create-user [isEdit] = "isEdit" [assignedPackageId]="packageToAssign" [clientAccountId]="0" [schoolData]="createdSchoolDetails" [schoolId] = "createdSchoolId"></app-create-user>
    </div>
    <div class="sticky-btns w-100" *ngIf="createIndividualSchoolForm">
      <div class="row w-100">
        <div class="col-sm-6 text-start">
          <button *ngIf="currentStep != steps.AssignPackage" type="button" class="btn theme-btn-outline px-5"
            (click)="handleBack()">
            Back
          </button>
          <button *ngIf="currentStep == steps.AssignPackage && !isEdit" type="button" class="btn theme-btn-outline px-5" 
          (click)="resetCreateIndependentSchoolCreationProcess()">
          Cancel
        </button>
        </div>
        <div class="col-sm-6 text-end">      
          <button *ngIf="currentStep == steps.AddSchool || currentStep == steps.CreateRole" type="button" class="btn theme-btn-outline px-5 ms-3 me-2" (click)="partialSave = true; triggerAction()">
            {{ "Submit" }}
          </button>
          <button type="button" class="btn theme-btn px-5 ms-0" (click)="triggerAction()">
            {{ currentStep == steps.CreateUser ? "Submit" : "Next" }}
          </button>        
        </div>
      </div>
    </div>
  </div>
</section>